/**
 * Helper to gather ALL specialties of a driver: legacy slots (specialty,
 * specialty2) + extra slots unlocked via paid trainings (extraSpecialties[]).
 * Use this everywhere instead of reading the fields directly so the rest of
 * the codebase keeps working as we move past the 2-spec cap.
 */
export const getDriverSpecialties = (driver) => {
  if (!driver) return [];
  return [
    driver.specialty,
    driver.specialty2,
    ...(driver.extraSpecialties || []),
  ].filter(Boolean);
};

/**
 * Cost multiplier when buying a new specialty:
 *   slots 1 and 2 → x1.0 (the historical free + 1st slot pricing)
 *   slot 3        → x1.5
 *   slot 4        → x2.0
 *   slot 5        → x2.5
 *   slot N        → 1 + 0.5 * (N - 2)  for N >= 2
 *
 * `currentCount` is the number of specialties the driver already has BEFORE
 * the purchase. The returned multiplier applies to the base training cost.
 */
export const getSpecialtyCostMultiplier = (currentCount) => {
  if (currentCount < 2) return 1.0;
  return 1 + 0.5 * (currentCount - 1);
};
